import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b464d7a")

_pushScopeId("data-v-5b464d7a")
const _hoisted_1 = { class: "social-post-preview card border-0 shadow-none h-100" }
const _hoisted_2 = { class: "card-body p-5" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h5", { class: "social-post-preview__title mb-4" }, "Post Preview", -1)
const _hoisted_4 = { class: "social-post-preview__panel" }
const _hoisted_5 = {
  key: 0,
  class: "social-post-preview__empty"
}
const _hoisted_6 = { class: "social-post-preview__empty-icons mb-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0" }, "Select a social account to preview your post here.", -1)
const _hoisted_8 = {
  key: 1,
  class: "social-post-preview__cards"
}
const _hoisted_9 = { class: "social-post-preview__mock-header" }
const _hoisted_10 = { class: "flex-grow-1 min-w-0" }
const _hoisted_11 = { class: "fw-semibold text-gray-800 text-truncate" }
const _hoisted_12 = { class: "text-muted fs-8" }
const _hoisted_13 = {
  key: 0,
  class: "social-post-preview__type-badge"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "text-muted fs-4" }, "···", -1)
const _hoisted_15 = {
  key: 0,
  class: "social-post-preview__caption"
}
const _hoisted_16 = {
  key: 1,
  class: "social-post-preview__caption text-muted"
}
const _hoisted_17 = {
  key: 2,
  class: "social-post-preview__media-video"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fas fa-play-circle fs-2x text-white" }, null, -1)
const _hoisted_19 = {
  key: 3,
  class: "social-post-preview__link"
}
const _hoisted_20 = { class: "social-post-preview__link-url text-truncate" }
const _hoisted_21 = {
  key: 4,
  class: "social-post-preview__comment"
}
const _hoisted_22 = { class: "social-post-preview__comment-avatar" }
const _hoisted_23 = { class: "social-post-preview__comment-body" }
const _hoisted_24 = { class: "fw-semibold fs-8" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = $event)),
        class: "social-post-preview__tabs"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_tab_pane, {
            label: "All",
            name: "all"
          }),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.previewPlatforms, (platform) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: platform,
              label: _ctx.getPlatformMeta(platform).label,
              name: platform
            }, null, 8, ["label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode("div", _hoisted_4, [
        (!_ctx.hasSelectedAccounts)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.previewIcons, (icon) => {
                  return (_openBlock(), _createBlock("span", {
                    key: icon,
                    class: "social-post-preview__empty-icon"
                  }, [
                    _createVNode("i", { class: icon }, null, 2)
                  ]))
                }), 128))
              ]),
              _hoisted_7
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.visibleAccounts, (account) => {
                return (_openBlock(), _createBlock("div", {
                  key: _ctx.accountKey(account),
                  class: ["social-post-preview__mock-card", _ctx.cardClass(account)]
                }, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", {
                      class: "social-post-preview__avatar",
                      style: { backgroundColor: _ctx.getPlatformMeta(account.platform).color }
                    }, [
                      _createVNode("i", {
                        class: _ctx.getPlatformMeta(account.platform).icon
                      }, null, 2)
                    ], 4),
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, _toDisplayString(_ctx.accountDisplayName(account)), 1),
                      _createVNode("div", _hoisted_12, [
                        _createTextVNode(_toDisplayString(_ctx.getPlatformMeta(account.platform).label) + " ", 1),
                        (_ctx.facebookTypeBadge(account))
                          ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.facebookTypeBadge(account)), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _hoisted_14
                  ]),
                  (_ctx.caption)
                    ? (_openBlock(), _createBlock("div", _hoisted_15, _toDisplayString(_ctx.caption), 1))
                    : (_openBlock(), _createBlock("div", _hoisted_16, "Your post content will appear here.")),
                  (_ctx.resolvedMedia.length)
                    ? (_openBlock(), _createBlock("div", {
                        key: 2,
                        class: ["social-post-preview__media-grid", {
                'social-post-preview__media-grid--vertical': _ctx.isVerticalFacebookFormat(account),
                'social-post-preview__media-grid--single': _ctx.resolvedMedia.length === 1
              }]
                      }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.resolvedMedia, (item, index) => {
                          return (_openBlock(), _createBlock("div", {
                            key: `${item.url}-${index}`,
                            class: "social-post-preview__media-item"
                          }, [
                            (item.isVideo)
                              ? (_openBlock(), _createBlock("video", {
                                  key: 0,
                                  class: "social-post-preview__media-player",
                                  src: item.url,
                                  controls: "",
                                  playsinline: "",
                                  preload: "metadata"
                                }, null, 8, ["src"]))
                              : (_ctx.isImageUrl(item.url))
                                ? (_openBlock(), _createBlock("img", {
                                    key: 1,
                                    src: item.url,
                                    alt: "Media preview"
                                  }, null, 8, ["src"]))
                                : (_openBlock(), _createBlock("div", _hoisted_17, [
                                    _hoisted_18
                                  ]))
                          ]))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.linkUrl)
                    ? (_openBlock(), _createBlock("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, _toDisplayString(_ctx.linkUrl), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showFollowUpComment(account))
                    ? (_openBlock(), _createBlock("div", _hoisted_21, [
                        _createVNode("div", _hoisted_22, [
                          _createVNode("i", {
                            class: _ctx.getPlatformMeta(account.platform).icon
                          }, null, 2)
                        ]),
                        _createVNode("div", _hoisted_23, [
                          _createVNode("div", _hoisted_24, _toDisplayString(_ctx.accountDisplayName(account)), 1),
                          _createVNode("div", null, _toDisplayString(_ctx.followUpComment), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ]))
      ])
    ])
  ]))
})